import React from 'react';
import { FirebaseUser } from '../types/user';
import './stylesheets/EmailUsersModal.css';

interface EmailUsersModalProps {
  users: FirebaseUser[];
  onClose: () => void;
}

const EmailUsersModal: React.FC<EmailUsersModalProps> = ({ users, onClose }) => {
  // Lock body scroll when modal is open
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleEmailAllUsers = () => {
    const emails = users.map(user => user.email).join(',');
    const mailtoLink = `mailto:?bcc=${encodeURIComponent(emails)}`;
    window.location.href = mailtoLink;
  };

  const handleEmailSubbedUsers = () => {
    const subbedUsers = users.filter(user => 
      Array.isArray(user.unlockedSpecialties) && user.unlockedSpecialties.length > 0
    );
    const emails = subbedUsers.map(user => user.email).join(',');
    const mailtoLink = `mailto:?bcc=${encodeURIComponent(emails)}`;
    window.location.href = mailtoLink;
  };

  const handleEmailUnsubbedUsers = () => {
    const unsubbedUsers = users.filter(user => 
      !Array.isArray(user.unlockedSpecialties) || user.unlockedSpecialties.length === 0
    );
    const emails = unsubbedUsers.map(user => user.email).join(',');
    const mailtoLink = `mailto:?bcc=${encodeURIComponent(emails)}`;
    window.location.href = mailtoLink;
  };

  const allUsersCount = users.length;
  const subbedUsersCount = users.filter(user => 
    Array.isArray(user.unlockedSpecialties) && user.unlockedSpecialties.length > 0
  ).length;
  const unsubbedUsersCount = users.filter(user => 
    !Array.isArray(user.unlockedSpecialties) || user.unlockedSpecialties.length === 0
  ).length;

  return (
    <div className="email-modal-overlay" onClick={onClose}>
      <div className="email-modal-content" onClick={e => e.stopPropagation()}>
        <div className="email-modal-header">
          <h2>Email Users</h2>
          <button className="email-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="email-modal-body">
          <p>Choose which group of users you'd like to email:</p>
          
          <div className="email-options">
            <button 
              className="email-option-button" 
              onClick={handleEmailAllUsers}
              disabled={allUsersCount === 0}
            >
              <div className="email-option-title">Email All Users</div>
              <div className="email-option-count">{allUsersCount} users</div>
            </button>
            
            <button 
              className="email-option-button" 
              onClick={handleEmailSubbedUsers}
              disabled={subbedUsersCount === 0}
            >
              <div className="email-option-title">Email Subscribed Users</div>
              <div className="email-option-count">{subbedUsersCount} users with specialties</div>
            </button>
            
            <button 
              className="email-option-button" 
              onClick={handleEmailUnsubbedUsers}
              disabled={unsubbedUsersCount === 0}
            >
              <div className="email-option-title">Email Unsubscribed Users</div>
              <div className="email-option-count">{unsubbedUsersCount} users without specialties</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailUsersModal;